const carouselItems = [
  {
    title: '2026年暑期档观剧指南',
    desc: '今夏最全追剧攻略，涵盖悬疑、古装、都市、科幻等热门分类，一篇搞定你的暑期片单。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20and%20TV%20watching%20guide%20collage%2C%20vibrant%20warm%20colors%2C%20popcorn%20and%20film%20reels%2C%20entertainment%20guide%20magazine%20cover%20style%2C%20fun%20summer%20vibes%2C%20cinematic%20flat%20lay%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '豆瓣9分以上必看神剧合集',
    desc: '精选近十年豆瓣评分9.0以上的口碑神剧，从国产剧到海外剧，每一部都是不容错过的经典。',
    img: 'https://readdy.ai/api/search-image?query=Collection%20of%20highly%20rated%20TV%20shows%20and%20movies%20posters%20on%20display%2C%20golden%20award%20trophies%2C%20premium%20quality%20entertainment%20concept%2C%20warm%20elegant%20lighting%2C%20curated%20collection%20aesthetic&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '一人追剧不孤单：弹幕文化解析',
    desc: '深入了解人人影视弹幕社区文化，看看千万网友如何边看边聊。弹幕互动让你的观影体验更有趣。',
    img: 'https://readdy.ai/api/search-image?query=Online%20streaming%20community%20concept%20with%20floating%20text%20messages%20on%20screen%2C%20social%20watching%20experience%2C%20warm%20digital%20colors%2C%20modern%20internet%20culture%20visual%2C%20engaging%20interactive%20design&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '从入门到精通：字幕术语全解',
    desc: '硬字幕、软字幕、外挂字幕、双语字幕……一篇搞懂所有字幕类型。从此找资源不再迷茫。',
    img: 'https://readdy.ai/api/search-image?query=Subtitles%20and%20translation%20concept%20design%2C%20multilingual%20text%20on%20film%20screen%2C%20educational%20guide%20visual%2C%20warm%20study%20atmosphere%2C%20clean%20modern%20typography%20layout%2C%20cinema%20knowledge%20sharing&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '人人影视2026上半年数据报告',
    desc: '半年播放量破百亿，最受欢迎剧集、最多弹幕、最高评分全面盘点。看看你的喜好是否和大家一样。',
    img: 'https://readdy.ai/api/search-image?query=Data%20report%20and%20analytics%20visualization%20with%20charts%20and%20graphs%2C%20warm%20business%20intelligence%20style%2C%20modern%20infographic%20design%2C%20professional%20annual%20report%20aesthetic%2C%20clean%20data%20presentation&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section
      id="carousel"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100 scroll-mt-16"
    >
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
          焦点专题
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.title}
              className="group rounded-lg overflow-hidden bg-background-50 cursor-pointer flex flex-col"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}